import type { AppDefinition } from '../../types/apps';

export const FeedbackAppDefinition: AppDefinition = {
  appId: 'feedback',
  name: 'Send feedback',
  version: '1.0.0',
  description: 'Send feedback to the River team.',

  entityTypes: [],
  requiresEntity: false,
  requiresProps: false,

  component: 'feedback',

  icon: {
    type: 'phosphor',
    phosphorIcon: 'Bug',
    phosphorWeight: 'duotone',
    color: '#64748b',
    metadata: {
      source: 'app',
      appId: 'feedback',
      isAppIcon: true,
    },
  },

  defaultWindowSize: { width: 400, height: 280, maxWidth: 400, maxHeight: 280 },

  category: 'system',
  isCore: true,
  isSystem: true,
  hidden: true,
};

export default FeedbackAppDefinition;
